import React, { ReactNode } from 'react';

import Spinner from '@/src/components/common/Elements/Spinner/Spinner';

import TreatmentHeader from './TreatmentHeader';

import DeleteDraftButton from '../../../Elements/DeleteDraftButton/DeleteDraftButton';
import TreatmentLayout from '../../TreatmentLayout/TreatmentLayout';

const TreatmentFormLayout = ({
  isDraft = false,
  isLoading = false,
  isFormLoading = false,
  footer,
  banner,
  children,
  treatmentFormHeight = '',
  onBack,
  onDeleteDraft,
}: {
  isAutomationLoading?: boolean;
  isViewMode: boolean;
  footer: ReactNode;
  banner: ReactNode;
  isLoading?: boolean;
  isFormLoading?: boolean;
  children?: ReactNode;
  containerClassName?: string;
  treatmentFormHeight?: string;
  automationBannerContent?: React.ReactNode;
  onBack: () => void;
} & {
  isDraft: boolean;
  onDeleteDraft?: () => void;
}) => {
  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <TreatmentLayout
        header={
          <TreatmentHeader title="New Expense">
            {isDraft && <DeleteDraftButton onClick={onDeleteDraft} isDisabled={isFormLoading} />}
          </TreatmentHeader>
        }
        footer={footer}
        banner={banner}
        treatmentFormHeight={treatmentFormHeight}
        onBack={onBack}
      >
        {children}
      </TreatmentLayout>
    </React.Fragment>
  );
};

export default TreatmentFormLayout;
